import React, { useContext, useState } from "react";
import { FormControl } from "react-bootstrap";
import Button from "react-bootstrap/esm/Button";
import Modal from "react-bootstrap/esm/Modal";
import { toast } from "react-toastify";
import { Store } from "../Store";
import useAxios from "../hooks/useAxios";

export default function TableExchange(props) {
  const [changeWithTableNum, setChangeWithTableNum] = useState(0);
  const { show, setShow, carts, changeThisTableNum } = props;

  const axios = useAxios();

  const { dispatch: ctxDispatch } = useContext(Store);

  const handleSave = async () => {
    if (!changeWithTableNum) {
      toast.error("Lütfen bir masa numarası seçiniz");
      return;
    }
    try {
      const { data: data1 } = carts[changeThisTableNum - 1].tableCode
        ? { data: carts[changeThisTableNum - 1] }
        : await axios.get(`/api/customer?tableNum=${changeThisTableNum}`);

      const { data: data2 } = carts[changeWithTableNum - 1].tableCode
        ? { data: carts[changeWithTableNum - 1] }
        : await axios.get(`/api/customer?tableNum=${changeWithTableNum}`);

      await axios.put(
        `/api/customer/relocate/${data1.tableCode}/${data2.tableCode}`,
        {}
      );

      setShow(false);
      toast.success("Masa başarılı bir şekilde degistirildi!");
    } catch {
      setShow(false);
      toast.error("Masa degistirilemedi!");
    }
  };

  return (
    <Modal show={show} onHide={() => setShow(false)}>
      <Modal.Header closeButton>
        <Modal.Title>{changeThisTableNum} Nolu Masayı Değiştir</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3"> Hangi masa ile değiştirmek istersiniz?</div>
        <div>
          <FormControl
            as="select"
            value={changeWithTableNum}
            onChange={(e) => {
              setChangeWithTableNum(e.target.value);
            }}
          >
            <option key={0} value={0}>
              {"Masa seçiniz"}
            </option>
            {carts.map((c, i) => {
              if (c.cartItems.length === 0) {
                return (
                  <option key={i + 1} value={i + 1}>
                    {"Masa " + (i + 1)}
                  </option>
                );
              }
              return null;
            })}
          </FormControl>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShow(false)}>
          Kapat
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Kaydet
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
